import React from 'react'
import workInProgress from '../../assets/images/work_in_progress.png'

const styles = {
    error_page: `w-screen container h-full flex justify-center items-center  text-center bg-[rgba(255,255,255,0.11)] rounded-md backdrop-filter backdrop-blur-[12.5px]`,
    image: `mx-auto max-h-[350px]`
}

const WorkInProgress = () => {
  return (
    <div className={styles.error_page}>
        <img src={workInProgress} className={styles.image} alt="Pending" />
    </div>
  )
}

export default WorkInProgress